import React from 'react';
import Lottie from 'react-lottie-player';
import LoadingAnimation from '../../resources/assets/animations/LoadingAnimation.json';

function LoadingView() {
  return (
    <div className="relative -mx-8 bg-center bg-cover justify-center items-center c-app c-default-layout bg-white">
      <Lottie
        play
        loop
        animationData={LoadingAnimation}
        rendererSettings={{
          preserveAspectRatio: 'xMidYMid slice',
        }}
        style={{
          height: '150px',
          width: '150px',
        }}
      />
    </div>
  );
}

export default LoadingView;
